// USED IN CHANGE ORDERS

export const approvalStatusList = [
  { value: 'APPROVED', label: 'Approved'},
  { value: 'PENDING_APPROVAL', label: 'Pending Approval' },
  { value: 'DECLINED', label: 'Declined' },
];

export const itemMarkupTypes = [
  { value: 'PERCENT', label: '%' },
  { value: 'DOLLAR', label: '$' },
  { value: 'DOLLAR_UNIT', label: '$/UNIT' },
  { value: 'DOUBLE_DASH', label: '--' },
];

export const itemCostTypes = [
  {
    code: 'LABOR',
    label: 'Labor',
  },
  {
    code: 'OTHER',
    label: 'Other',
  },
];

// USED IN SUB VENDORS

export const reminderLimits = [
  { label: '1 Day', value: 1 },
  { label: '2 Days', value: 2 },
  { label: '3 Days', value: 3 },
  { label: '4 Days', value: 4 },
  { label: '5 Days', value: 5 },
];

export const notificationList = {
  groupings: [
    // {
    //   name: 'Project Management',
    //   subgroups: [
    //     {
    //       name: 'Tasks',
    //       items: [
    //         {
    //           id: 1,
    //           description: 'Tasks marked as complete',
    //           value: true,
    //         },
    //       ],
    //     },
    //     {
    //       name: 'Charge Orders',
    //       items: [
    //         {
    //           id: 2,
    //           description: 'Charge Orders approved by Owner',
    //           value: true,
    //         },
    //       ],
    //     },
    //     {
    //       name: 'Selections',
    //       items: [
    //         {
    //           id: 3,
    //           description: 'Selection choice approved as a Vendor',
    //           value: true,
    //         },
    //         {
    //           id: 4,
    //           description: 'Selection choice approved as a Installer',
    //           value: true,
    //         },
    //       ],
    //     },
    //     {
    //       name: 'Warranty',
    //       items: [
    //         {
    //           id: 5,
    //           description: 'Service Appointment acceptance request',
    //           value: true,
    //         },
    //         {
    //           id: 6,
    //           description: 'Service Appointment scheduled',
    //           value: true,
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      name: 'Financial',
      subgroups: [
        {
          name: 'Bids',
          items: [
            {
              id: 7,
              description: 'New comment on a Bid Request',
              value: true,
            },
            {
              id: 8,
              description: 'Bid Request released by Builder',
              value: true,
            },
            {
              id: 9,
              description: 'Bid Request approved by Builder',
              value: true,
            },
            {
              id: 10,
              description: 'Bid Request declined by Builder',
              value: true,
            },
            {
              id: 11,
              description: 'Bid Request status reset to `in progress` by Builder',
              value: true,
            },
            {
              id: 12,
              description: 'Bid Submitted by Builder',
              value: true,
            },
            {
              id: 13,
              description: 'Bid Package reopened',
              value: true,
            },
            {
              id: 14,
              description: 'Bid Package deadline reminder',
              value: true,
            },
            {
              id: 15,
              description: 'Bid Attached to a Bid Package',
              value: true,
            },
            {
              id: 16,
              description: 'Bid Request receipt sent',
            },
          ],
        },
        {
          name: 'Purchase Orders',
          items: [
            {
              id: 17,
              description: 'Purchase order released by Builder',
              value: true,
            },
            {
              id: 18,
              description: 'Purchase order approval reminder',
              value: true,
            },
            {
              id: 19,
              description: 'Files attached to a lien Waiver',
              value: true,
            },
            {
              id: 20,
              description: 'Purchase order work completed by a Sub/Vendor',
              value: true,
            },
            {
              id: 21,
              description: 'Payment made on a Purchase Order',
              value: true,
            },
            {
              id: 22,
              description: 'Purchase order payment receipt sent',
              value: true,
            },
          ],
        },
      ],
    }
    // {
    //   name: 'Administrative',
    //   subgroups: [
    //     {
    //       name: 'Sub/Vendors Information',
    //       items: [
    //         {
    //           id: 23,
    //           description: 'Insurance reminder',
    //           value: false,
    //         },
    //       ],
    //     },
    //   ],
    // },
  ],
};

export const divisions = [
  { value: 'ELETRICAL', label: 'Eletrical' },
  { value: 'EQUIPAMENT', label: 'Equipament' },
  { value: 'DOORS_WINDOWS', label: 'Doors & Windows' },
];

// USED IN TASKS

export const tasksNotificationList = {
  groupings: [
    {
      name: 'Project Management',
      subgroups: [
        {
          name: 'Tasks',
          items: [
            {
              id: 1,
              description: 'Tasks marked as complete',
              value: true,
            },
          ],
        },
        {
          name: 'Change Orders',
          items: [
            {
              id: 2,
              description: 'Change Orders approved by Owner',
              value: true,
            },
          ],
        },
        {
          name: 'Selections',
          items: [
            {
              id: 3,
              description: 'Selection choice approved as a Vendor',
              value: true,
            },
            {
              id: 4,
              description: 'Selection choice approved as a Installer',
              value: true,
            },
          ],
        },
        {
          name: 'Warranty',
          items: [
            {
              id: 5,
              description: 'Service Appointment acceptance request',
              value: true,
            },
            {
              id: 6,
              description: 'Service Appointment scheduled',
              value: true,
            },
          ],
        },
      ],
    },
    // {
    //   name: 'Financial',
    //   subgroups: [
    //     {
    //       name: 'Bids',
    //       items: [
    //         {
    //           id: 7,
    //           description: 'New comment on a Bid Request',
    //           value: true,
    //         },
    //         {
    //           id: 8,
    //           description: 'Bid Request released by Builder',
    //           value: true,
    //         },
    //         {
    //           id: 9,
    //           description: 'Bid Request approved by Builder',
    //           value: true,
    //         },
    //         {
    //           id: 10,
    //           description: 'Bid Request declined by Builder',
    //           value: true,
    //         },
    //         {
    //           id: 11,
    //           description: 'Bid Request status reset to `in progress` by Builder',
    //           value: true,
    //         },
    //         {
    //           id: 12,
    //           description: 'Bid Submitted by Builder',
    //           value: true,
    //         },
    //         {
    //           id: 13,
    //           description: 'Bid Package reopened',
    //           value: true,
    //         },
    //         {
    //           id: 14,
    //           description: 'Bid Package deadline reminder',
    //           value: true,
    //         },
    //         {
    //           id: 15,
    //           description: 'Bid Attached to a Bid Package',
    //           value: true,
    //         },
    //         {
    //           id: 16,
    //           description: 'Bid Request receipt sent',
    //         },
    //       ],
    //     },
    //     {
    //       name: 'Purchase Orders',
    //       items: [
    //         {
    //           id: 17,
    //           description: 'Purchase order released by Builder',
    //           value: true,
    //         },
    //         {
    //           id: 18,
    //           description: 'Purchase order approval reminder',
    //           value: true,
    //         },
    //         {
    //           id: 19,
    //           description: 'Files attached to a lien Waiver',
    //           value: true,
    //         },
    //         {
    //           id: 20,
    //           description: 'Purchase order work completed by a Sub/Vendor',
    //           value: true,
    //         },
    //         {
    //           id: 21,
    //           description: 'Payment made on a Purchase Order',
    //           value: true,
    //         },
    //         {
    //           id: 22,
    //           description: 'Purchase order payment receipt sent',
    //           value: true,
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      name: 'Administrative',
      subgroups: [
        {
          name: 'Sub/Vendors Information',
          items: [
            {
              id: 23,
              description: 'Insurance reminder',
              value: false,
            },
          ],
        },
      ],
    }
  ],
};

// export const tags = [
//   { name: 'contractions', id: 1 },
//   { name: 'contractor', id: 2 },
//   { name: 'builder', id: 3 },
//   { name: 'remodeling', id: 4 },
//   { name: 'construed', id: 5 },
//   { name: 'management', id: 6 },
//   { name: 'general contractor', id: 7 },
//   { name: 'building construction', id: 8 },
//   { name: 'worker', id: 9 },
//   { name: 'materials', id: 10 },
//   { name: 'const', id: 11 },
//   { name: 'site', id: 12 },
//   { name: 'license', id: 13 },
//   { name: 'new', id: 14 },
//   { name: 'jobs', id: 15 },
//   { name: 'building contractors', id: 16 },
//   { name: 'near me', id: 17 },
//   { name: 'tiny house builders', id: 18 },
//   { name: 'new construction', id: 19 },
//   { name: 'engineering', id: 20 },
// ];

export const fallbackImage =
  'data:image/png;base64,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';


// USED IN TASKS AND WARRANTY

export const priorities = [
  { value: 'LOW', label: 'Low' },
  { value: 'HIGH', label: 'High' },
];

// USED IN TASKS AND SUB VENDORS

export const projectsAlternative = [
  {
    project_id: 1,
    create_date: '2022-12-12T15:33:53.319Z',
    name: 'Home Towne Aurora',
    project_viewing_acess: true,
    status: 'OPEN',
  },
  {
    project_id: 2,
    create_date: '2022-12-12T15:33:53.319Z',
    name: 'Electronic Hat',
    project_viewing_acess: true,
    status: 'OPEN',
  },
  {
    project_id: 3,
    create_date: '2022-12-12T15:33:53.319Z',
    name: 'Granite Hat',
    project_viewing_acess: true,
    status: 'CLOSED',
  },
];

// USED IN WARRANTY

export const serviceCoordinatorsInitialValue = [
  {
    id: 1,
    name: 'Admin',
    email: '33admin@jmcquality.com',
    image: 'https://uploads.jmc.voxtell.app/9746459c-55f3-49f7-aaa7-f1e256317532.png',
    status: 'ACTIVE',
    roleDescription: 'Administrador',
  },
];

export const classifications = [
  { value: 'ELEVEN_MONTH', label: '11 MONTH' },
  { value: 'TWELVE_MONTH', label: '12 MONTH' },
  { value: 'THIRTY_DAY', label: '30 DAY' },
  { value: 'SIXTY_DAY', label: '60 DAY' },
  { value: 'HOLDING_UNTIL', label: 'HOLDING UNTIL' },
  { value: 'NEEDS_INSPECTION', label: 'NEEDS INSPECTION' },
  { value: 'PRE_CLOSE', label: 'PRE-CLOSE' },
  { value: 'PUNCH_LIST', label: 'PUNCH LIST' },
  { value: 'OTHER', label: 'OTHER' },
  { value: 'MEETS_WARRANTY_STANDAEDS', label: 'MEETS WARRANTY STANDAEDS (CLOSED)' },
  { value: 'NON_WARRANTY', label: 'NON-WARRANTY (CLOSED)' },
  { value: 'SERVICE_COMPLETED', label: 'SERVICE COMPLETED (CLOSED)' },
];